module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_gamepub_m.c84bca385abc943dc0a3766131854185.png";